(function () {
  var FREE_HANDLE_RE = /(?:^|\/|-)(mini|free-sample|freebie|free-gift|free_sample|freebies)(?:$|\/|-)/i;
  var SKIP_CARD_CLASSES = {
    'tb-pcard': true,
    'product-item': true,
    'not-sca-qv': true,
    'recommended-pro': true,
    'product-item--zoom': true,
    'product-item--move': true,
    'tb-mc-crosssell-pcard': true
  };
  var enforceTimer;
  var enforcing = false;

  function getAllowedCount(paidSubtotalCents) {
    var rupees = paidSubtotalCents / 100;
    if (typeof window.getAllowedGiftCount === 'function') {
      return window.getAllowedGiftCount(rupees);
    }
    if (rupees < 1499) return 0;
    if (rupees < 3499) return 1;
    if (rupees < 5499) return 2;
    return 3;
  }

  function isOnFreebiesPage() {
    return window.location.pathname.indexOf('/collections/freebies') !== -1;
  }

  function isFreeGiftHandle(handle) {
    handle = String(handle || '').toLowerCase();
    if (!handle) return isOnFreebiesPage();
    return FREE_HANDLE_RE.test(handle);
  }

  function isFreeGiftLine(item) {
    if (!item) return false;

    if (isFreeGiftHandle(item.handle)) return true;

    var price = Number(item.price);
    var originalPrice = Number(item.original_price);
    var finalLine = Number(item.final_line_price);
    var originalLine = Number(item.original_line_price);

    if (finalLine === 0 && (price === 0 || originalPrice === 0 || originalLine === 0)) {
      return true;
    }

    return false;
  }

  function getPaidSubtotalCents(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isFreeGiftLine(item)) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function countFreeGiftUnits(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (!isFreeGiftLine(item)) return sum;
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function getHandleFromCard(el) {
    var root = el && el.closest('.tb-pcard, .product-item, [data-pcard-root]');
    if (!root) return '';

    var classes = String(root.className || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      var cls = classes[i].trim();
      if (!cls || SKIP_CARD_CLASSES[cls] || cls.indexOf('product-item__') === 0 || cls.indexOf('tb-') === 0) {
        continue;
      }
      return cls;
    }
    return '';
  }

  function getVariantIdFromElement(el) {
    if (!el) return null;

    var form = el.closest('form');
    if (form) {
      var input = form.querySelector('[name="id"], .item-varid');
      if (input && input.value) return input.value;
    }

    var root = el.closest('.tb-pcard, .product-item, [data-pcard-root]');
    if (root) {
      var active = root.querySelector('.product-item__variant.active, .tb-pcard__shade.active');
      if (active && active.dataset.varid) return active.dataset.varid;

      var hidden = root.querySelector('.item-varid, [name="id"]');
      if (hidden && hidden.value) return hidden.value;
    }

    return null;
  }

  function isFreeGiftAddAttempt(handle, variantId) {
    if (isFreeGiftHandle(handle)) return true;
    if (isOnFreebiesPage()) return true;
    return false;
  }

  function hasFreeGiftVariantInCart(cart, variantId, handle) {
    return (cart.items || []).some(function (item) {
      if (!isFreeGiftLine(item)) return false;
      if (variantId && String(item.variant_id) === String(variantId)) return true;
      if (handle && String(item.handle || '').toLowerCase() === String(handle).toLowerCase()) return true;
      return false;
    });
  }

  function canAddFreeGift(cart, handle, variantId) {
    if (!isFreeGiftAddAttempt(handle, variantId)) return true;

    var paidSubtotal = getPaidSubtotalCents(cart);
    var allowed = getAllowedCount(paidSubtotal);
    var freeUnits = countFreeGiftUnits(cart);

    if (paidSubtotal <= 0 || allowed === 0) return false;
    if (freeUnits >= allowed) return false;
    if (hasFreeGiftVariantInCart(cart, variantId, handle)) return false;

    return true;
  }

  function showBlockedMessage(cart) {
    var paidSubtotal = getPaidSubtotalCents(cart);
    var allowed = getAllowedCount(paidSubtotal);

    if (paidSubtotal <= 0) {
      window.alert('Add a paid product to your bag first to unlock free gifts.');
      return;
    }

    if (allowed === 0) {
      window.alert('Spend ₹1,499 or more on paid products to unlock free gifts.');
      return;
    }

    window.alert('You can add up to ' + allowed + ' free gift(s), one of each, for your current order value.');
  }

  function changeLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, quantity) })
    }).then(function (res) {
      return res.json();
    });
  }

  function refreshCartUi() {
    if (window.TBMiniCart && typeof window.TBMiniCart.refresh === 'function') {
      return window.TBMiniCart.refresh();
    }
    if (typeof window.refreshCart === 'function') {
      window.refreshCart(true);
    }
  }

  function enforceFreeGiftRules(cart) {
    if (enforcing || !cart || !cart.items) return Promise.resolve(cart);

    var paidSubtotal = getPaidSubtotalCents(cart);
    var allowed = getAllowedCount(paidSubtotal);
    var freeLines = cart.items.filter(isFreeGiftLine);
    var freeUnits = countFreeGiftUnits(cart);
    var changes = [];

    if ((paidSubtotal === 0 || allowed === 0) && freeUnits > 0) {
      freeLines.forEach(function (line) {
        changes.push({ key: line.key, quantity: 0 });
      });
    } else {
      var remaining = allowed;

      freeLines.forEach(function (line) {
        var qty = Number(line.quantity || 0);
        var targetQty = 0;

        if (remaining > 0) {
          targetQty = Math.min(qty, 1, remaining);
          remaining -= targetQty;
        }

        if (qty !== targetQty) {
          changes.push({ key: line.key, quantity: targetQty });
        }
      });
    }

    var unique = {};
    changes.forEach(function (change) {
      unique[change.key] = change.quantity;
    });
    var changeList = Object.keys(unique).map(function (key) {
      return { key: key, quantity: unique[key] };
    });

    if (!changeList.length) {
      updateUiState(cart);
      return Promise.resolve(cart);
    }

    enforcing = true;

    return changeList
      .reduce(function (chain, change) {
        return chain.then(function () {
          return changeLine(change.key, change.quantity);
        });
      }, Promise.resolve())
      .then(function () {
        return fetchCart();
      })
      .then(function (nextCart) {
        updateUiState(nextCart);
        return refreshCartUi().then(function () {
          return nextCart;
        });
      })
      .finally(function () {
        enforcing = false;
      });
  }

  function updateFreeGiftAddButtons(cart) {
    var paidSubtotal = getPaidSubtotalCents(cart);
    var allowed = getAllowedCount(paidSubtotal);
    var freeUnits = countFreeGiftUnits(cart);
    var canAddMore = paidSubtotal > 0 && allowed > 0 && freeUnits < allowed;

    document.querySelectorAll('.add-to-con, [data-add-to-cart-cta]').forEach(function (el) {
      var handle = getHandleFromCard(el);
      if (!isFreeGiftAddAttempt(handle, null)) return;

      if (canAddMore) {
        el.style.removeProperty('display');
        el.removeAttribute('aria-hidden');
        el.classList.remove('tb-free-gift-add--blocked');
      } else {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
        el.classList.add('tb-free-gift-add--blocked');
      }
    });
  }

  function updateCheckoutState(cart) {
    var checkout = document.getElementById('checkout2');
    if (!checkout) return;

    var paidSubtotal = getPaidSubtotalCents(cart);
    var freeUnits = countFreeGiftUnits(cart);
    var allowed = getAllowedCount(paidSubtotal);
    var canCheckout = paidSubtotal > 0 && cart.total_price > 0;

    checkout.classList.toggle('is-disabled', !canCheckout);
    checkout.setAttribute('aria-disabled', canCheckout ? 'false' : 'true');
  }

  function updateUiState(cart) {
    updateCheckoutState(cart);
    updateFreeGiftAddButtons(cart);
  }

  function fetchCartAndEnforce() {
    return fetchCart().then(function (cart) {
      updateUiState(cart);
      return enforceFreeGiftRules(cart);
    });
  }

  function scheduleEnforce() {
    clearTimeout(enforceTimer);
    enforceTimer = setTimeout(fetchCartAndEnforce, 250);
  }

  function addVariantToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status === 422) {
          throw new Error(data.description || 'Could not add to cart');
        }
        if (typeof window.refreshCart === 'function') {
          window.refreshCart(true);
        }
        scheduleEnforce();
        return data;
      });
  }

  function guardAddAttempt(handle, variantId) {
    return fetchCart().then(function (cart) {
      if (!canAddFreeGift(cart, handle, variantId)) {
        showBlockedMessage(cart);
        return { blocked: true, cart: cart };
      }

      return addVariantToCart(variantId).then(function (data) {
        return { blocked: false, data: data };
      });
    });
  }

  function validateCheckout(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    return fetchCart()
      .then(function (cart) {
        return enforceFreeGiftRules(cart);
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        var paidSubtotal = getPaidSubtotalCents(cart);
        var freeUnits = countFreeGiftUnits(cart);
        var allowed = getAllowedCount(paidSubtotal);

        updateUiState(cart);

        if (paidSubtotal <= 0 || cart.total_price <= 0) {
          window.alert('Please add a paid product to your bag before checkout.');
          return;
        }

        if (freeUnits > allowed) {
          return enforceFreeGiftRules(cart).then(function () {
            return fetchCart();
          }).then(function (nextCart) {
            if (countFreeGiftUnits(nextCart) > getAllowedCount(getPaidSubtotalCents(nextCart))) {
              window.alert('Your free gifts were updated. Please review your bag and try again.');
              return;
            }
            window.location.href = '/checkout';
          });
          return;
        }

        window.location.href = '/checkout';
      })
      .catch(function () {
        window.alert('Could not validate your cart. Please try again.');
      });
  }

  function bindAddInterceptors() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          '.col-add-btn, .js-atc, [data-add-to-cart-cta] button, [data-add-to-cart-cta] input[type="submit"], .add-to-con button, .add-to-con input[type="submit"]'
        );
        if (!btn) return;

        var handle = getHandleFromCard(btn);
        var variantId = getVariantIdFromElement(btn);
        if (!isFreeGiftAddAttempt(handle, variantId)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (!variantId) return;

        guardAddAttempt(handle, variantId);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

        var submitter = e.submitter || form.querySelector('[type="submit"]');
        var handle = getHandleFromCard(form);
        var variantId = getVariantIdFromElement(submitter || form);
        if (!isFreeGiftAddAttempt(handle, variantId)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (!variantId) return;

        guardAddAttempt(handle, variantId);
      },
      true
    );
  }

  function bindCheckout() {
    document.addEventListener(
      'click',
      function (e) {
        var checkout = e.target.closest('#checkout2, .tb-mc__checkout');
        if (!checkout) return;
        e.preventDefault();
        e.stopPropagation();
        validateCheckout(e);
      },
      true
    );
  }

  function patchFetch() {
    if (window.__tbGiftFetchPatched) return;
    window.__tbGiftFetchPatched = true;

    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (!url || url.indexOf('/cart/add') === -1) {
        return nativeFetch(input, init);
      }

      var body = (init && init.body) || '';
      var payload = {};

      try {
        payload = typeof body === 'string' ? JSON.parse(body) : body || {};
      } catch (err) {
        return nativeFetch(input, init);
      }

      var variantId = payload.id || (payload.items && payload.items[0] && payload.items[0].id);
      var handle = payload.handle || '';

      if (!isFreeGiftAddAttempt(handle, variantId)) {
        return nativeFetch(input, init).then(function (res) {
          scheduleEnforce();
          return res;
        });
      }

      return fetchCart().then(function (cart) {
        if (!canAddFreeGift(cart, handle, variantId)) {
          showBlockedMessage(cart);
          return Promise.resolve(
            new Response(JSON.stringify({ status: 422, description: 'Free gift not allowed' }), {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            })
          );
        }

        return nativeFetch(input, init).then(function (res) {
          scheduleEnforce();
          return res;
        });
      });
    };
  }

  function init() {
    patchFetch();
    bindAddInterceptors();
    bindCheckout();
    scheduleEnforce();

    document.addEventListener('cart:updated', scheduleEnforce);
    document.addEventListener('cart:refresh', scheduleEnforce);
  }

  window.TBFreeGiftGuard = {
    enforce: fetchCartAndEnforce,
    schedule: scheduleEnforce,
    validateCheckout: validateCheckout,
    canAddFreeGift: canAddFreeGift,
    isFreeGiftLine: isFreeGiftLine,
    isFreeGiftHandle: isFreeGiftHandle,
    getPaidSubtotalCents: getPaidSubtotalCents,
    countFreeGiftUnits: countFreeGiftUnits
  };

  window.handlefreegift = validateCheckout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
